<template>
  <v-dialog v-model="localDialog" width="40%" @update:modelValue="updateDialog" transition=""persistent :open-delay="0" :close-delay="0">
    <v-card>
        <v-card-title class="text-h6">
            <span>{{ isEntryMode ? 'Add Company Module' : 'Update Company Module' }}</span>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-form @submit.prevent="submit" ref="CompnaySetup">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="company_id.value.value"
                    :items="getCompanyList.filter(item=> item.status == 1)"
                    :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                    item-value="id"
                    :error-messages="company_id.errorMessage.value"
                    clearable        
                    @update:modelValue="(value) => { this.tempId = value; this.showAvailableModule(this.tempId) }"             
                  >
                    <template #label>
                      Company <span class="text-red-accent-4">*</span>
                    </template>
                  </v-autocomplete> 
                  
                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="module_id.value.value"
                    :items="getTempCompanyModuleList.filter(item=> item.status == 1)"
                    :item-title="item => item && item.name && item.code ? `${item.name} - ${item.code}` : ''"                                                  
                    item-value="id"
                    :error-messages="module_id.errorMessage.value"
                    clearable                        
                  >
                    <template #label>
                      Module <span class="text-red-accent-4">*</span>
                    </template>
                  </v-autocomplete>                                    
                </v-col>
                <v-checkbox                            
                    label="Active"
                    v-model="status.value.value"
                    :error-messages="status.errorMessage.value"
                    density="compact"
                    variant="outlined"
                    hide-details
                    single-line
                    color="primary"
                    value="1"
                ></v-checkbox>
                <input v-model="company_module_id.value.value" type="hidden">
              </v-row>

              <v-divider></v-divider>
              <v-card-actions>
                  <v-layout class="justify-end">
                      <v-btn class="bg-red" variant="flat" type="reset"@click="closeDialog">Close</v-btn>
                        <v-btn 
                        class="bg-brand w-15 ms-2"  
                        variant="flat" 
                        type="submit"
                        >
                        {{ isEntryMode ? 'Save' : 'Update' }}
                        </v-btn>
                  </v-layout>
              </v-card-actions>
            </v-form>
        </v-card-text>
      
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'

export default {
  name: 'CompanyModuleSetup',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({
        company_id: '',
        module_id: '',
        status: '1',
        company_module_id: null,
      })
    }
  },
  data() {
    return {
      localDialog: this.dialog,
      errorMessages: '',
      loading: false,
      isEntryMode: true,
      tempId: ''
    }
  },
  computed: {
    getCompanyList() {
        return this.$store.getters.getCompanyList;
    },
    getModuleList() {
        return this.$store.getters.getModuleList;
    },
    getTempCompanyModuleList() {
        return this.$store.getters.getTempCompanyModuleList;
    },
    getCompanyModuleList() {
        return this.$store.getters.getCompanyModuleList;
    },
  },
  watch: {
    dialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:dialog', val)
    },
    data: {
      handler(newData) {
        this.isEntryMode = !newData.id;
        this.resetForm({ errors: {}, touched: {} });
        this.company_id.setValue(newData.company_id || '', false);
        this.module_id.setValue(newData.module_id || '', false);
        this.status.setValue(String(newData.status) || '1', false);
        this.company_module_id.setValue(newData.id || '', false);
      },
    }
    
  },
  created() {
        if(this.$store.getters.getCompanyList.length == 0){
            this.loading = true;
                this.$store.dispatch('getCompanyList').then((response) => {
                this.loading = false;
            })
        };

        if(this.$store.getters.getModuleList.length == 0){
            this.loading = true;
                this.$store.dispatch('getModuleList').then((response) => {
                this.loading = false;
            })
        };

        if(this.$store.getters.getCompanyModuleList.length == 0){
                this.loading = true;
                 this.$store.dispatch('getCompanyModuleList').then((response) => {
                    this.loading = false;
                })
        };
    },
  methods: {
    updateDialog(val) {
      this.$emit('update:dialog', val)
    },
    closeDialog() {
        this.$emit('update:dialog', false);
    },
    showAvailableModule(company_id){
      this.getReservedModule = this.getCompanyModuleList.filter(item => item.company_id == company_id).map(item => item.module_id);
      this.availableModule = this.getModuleList.filter(module => !this.getReservedModule.includes(module.id));
      this.$store.commit('SET_TEMP_COMPANY_MODULE_LIST', this.availableModule)
    }
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm({
      validationSchema: yup.object({
          company_id: yup.number().positive().integer().required().label('Company'),
          module_id: yup.number().positive().integer().required().label('Module'), 
      }),

    });

    const company_id = useField('company_id');
    const module_id = useField('module_id');
    const status = useField('status');
    const company_module_id = useField('company_module_id');
    const errorMessages  = ref('');
    const loading  = ref('');
    const buttonText  = ref('');
    buttonText.value = 'Save';
    const store = useStore();

    const submit = handleSubmit((values) => {
        store.dispatch("saveUpdateCompanyModule", values)
            .then((response) => {
                resetForm();
                emit('update:dialog', false);
                toast.success(response.data.message);
                loading.value = true;
                store.dispatch('getCompanyModuleList')
                    .then(data => {
                        loading.value = false;
                    })
                    .catch(error => {
                        loading.value = false;
                        toast.error(error.response.data.message);   
                    })
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      company_id,
      module_id,
      status,
      errorMessages,
      company_module_id,
      buttonText,
      resetForm,
      loading
    }
  },
  mounted() {
  }
}
</script>

